<svg viewBox="0 0 24 24" fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_65_8725)">
    <path d="M15.0005 15.8746L11.1205 11.9946L15.0005 8.11461C15.3905 7.72461 15.3905 7.09461 15.0005 6.70461C14.6105 6.31461 13.9805 6.31461 13.5905 6.70461L9.00047 11.2946C8.61047 11.6846 8.61047 12.3146 9.00047 12.7046L13.5905 17.2946C13.9805 17.6846 14.6105 17.6846 15.0005 17.2946C15.3805 16.9046 15.3905 16.2646 15.0005 15.8746Z" fill="black"/>
  </g>
  <defs>
    <clipPath id="clip0_65_8725">
      <rect fill="white"/>
    </clipPath>
  </defs>
</svg>
